import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function EnrolDialog({ course, title, onClose }) {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", phone: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/enrolments", { course_id: course.id, ...form });
      toast.success(t("courses.done", { t: title }));
      setForm({ name: "", phone: "" });
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!course} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-parchment max-w-md" data-testid="enrol-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-forest-800">{t("co.enrol")}</DialogTitle>
          <DialogDescription>{title}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>{t("co.name")}</Label><Input required minLength={2} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="enrol-name-input" /></div>
          <div className="space-y-1.5"><Label>{t("co.phone")}</Label><Input required inputMode="numeric" placeholder={t("co.phonePh")} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="enrol-phone-input" /></div>
          <p className="text-xs text-[#57645A]">{t("courses.note")}</p>
          <button disabled={busy} className="w-full flex items-center justify-center gap-2 bg-forest-800 hover:bg-forest-700 text-parchment font-semibold py-3.5 rounded-full disabled:opacity-60" data-testid="enrol-submit-button">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} {t("courses.submit")}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
